var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 41 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.818 23.185c-3.53-2.245-5.776-6.138-5.776-10.64C7.042 5.445 12.624 0 20.025 0S33.16 5.431 33.16 12.545c0 4.51-2.183 8.397-5.743 10.64h7.633c.957 0 1.78.654 2.013 1.596l3.102 12.613h.033C40.514 38.72 39.526 40 38.185 40H2.074C.715 40-.259 38.724.061 37.394l3.102-12.613c.237-.942 1.057-1.596 2.013-1.596z",
    clipRule: "evenodd"
  })));
};
export default SvgPerson;